import { useEffect } from 'react';
import { listenTurnos } from '../../channels/turnosChannel';
import { useTurnosStore } from '../../stores/useTurnosStore';
import { useScreenStore } from '../../stores/useScreenStore';

export function useTurnosChannel() {

    useEffect(() => {

        const unsubscribe = listenTurnos(({ tipo, payload }) => {

            const {screen} = useScreenStore.getState();

            const {
                setTurnos,
                setTurnosCodes,
                setTurnosSelecionados
            } = useTurnosStore.getState();

            if(screen === 'Filtros'){

                if (tipo === 'turnos-sync') {

                    setTurnos(payload, false);

                }

                if (tipo === 'turnos-codes-sync') {

                    setTurnosCodes(payload, false);

                }

            }

            if(screen === 'Home'){

                if (tipo === 'turnos-selected') {
                    setTurnosSelecionados(payload, false);
                }

            }

        });

        return unsubscribe;

    }, []);

}